import { Check, Close } from "@mui/icons-material";
import { Backdrop, Fade, Modal } from "@mui/material";
import React from "react";
import { CustomBtn, SecondaryBtn } from "../CustomBtn";

import {
  backdropProps,
  StyledModalBox,
  StyledHeaderBox,
  StyledTitle,
  StyledContentBox,
  StyledButtonsBox,
  StyledCloseButton,
} from "./CustomModal.styles";
import {
  DEFAULT_CANCEL_BTN_TEXT,
  DEFAULT_SAVE_BTN_TEXT,
} from "./CustomModal.constants";

const CustomModal = ({
  open,
  handleClose,
  title,
  children,
  onSave,
  onCancel,
  cancelBtnText,
  saveBtnText,
  saveIcon,
  width,
  height,
  disableBtn = false,
  noBtns = false,
}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: backdropProps,
        }}
      >
        <Fade in={open}>
          <StyledModalBox modalHeight={height} modalWidth={width}>
            <StyledHeaderBox>
              <StyledTitle>{title}</StyledTitle>
            </StyledHeaderBox>
            <StyledContentBox>{children}</StyledContentBox>
            {!noBtns && (
              <StyledButtonsBox>
                <SecondaryBtn
                  text={cancelBtnText || DEFAULT_CANCEL_BTN_TEXT}
                  noIcon
                  onClick={onCancel}
                />
                <CustomBtn
                  text={saveBtnText || DEFAULT_SAVE_BTN_TEXT}
                  Icon={saveIcon || Check}
                  onClick={onSave}
                  disabled={disableBtn}
                />
              </StyledButtonsBox>
            )}
          </StyledModalBox>
        </Fade>
      </Modal>

      {open && (
        <StyledCloseButton onClick={handleClose}>
          <Close />
        </StyledCloseButton>
      )}
    </>
  );
};

export default CustomModal;
